// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"07e30136","77":"953ad57d","88":"953ad57d","583":"953ad57d","848":"07e30136"}[chunkId] + ".chunk.css";
};